import {
  INDEXABLE_PATHS,
  PAGE_META,
  SITE_URL,
  normalizePath,
} from "./pageMeta";

// Bump when the preview images change so WhatsApp and Facebook fetch them again.
export const SHARE_IMAGE_VERSION = "20261008";

export function shareImageFor(pathname) {
  const path = normalizePath(pathname);
  const slug = path === "/" ? "home" : path.slice(1);
  return `/og/${slug}.jpg`;
}

export function absoluteShareImage(pathname) {
  return `${SITE_URL}${shareImageFor(pathname)}?v=${SHARE_IMAGE_VERSION}`;
}

const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

function upsertMeta(html, attr, key, content) {
  const tag = `<meta ${attr}="${key}" content="${escapeHtml(content)}" data-rh="true" />`;
  const re = new RegExp(`<meta\\s+${attr}=["']${key}["'][\\s\\S]*?>`, "i");
  if (re.test(html)) return html.replace(re, tag);
  return html.replace("</head>", `  ${tag}\n</head>`);
}

function upsertCanonical(html, href) {
  const tag = `<link rel="canonical" href="${escapeHtml(href)}" data-rh="true" />`;
  const re = /<link\s+rel=["']canonical["'][\s\S]*?>/i;
  if (re.test(html)) return html.replace(re, tag);
  return html.replace("</head>", `  ${tag}\n</head>`);
}

// Rewrite the tags WhatsApp, iMessage, LinkedIn, Slack, and X read from the
// raw HTML. Those apps do not run the React app.
export function applyShareTags(html, { title, description, url, image, robots }) {
  let next = html.replace(/<title>[\s\S]*?<\/title>/i, `<title>${escapeHtml(title)}</title>`);
  next = upsertCanonical(next, url);
  next = upsertMeta(next, "name", "description", description);
  next = upsertMeta(next, "name", "robots", robots);
  next = upsertMeta(next, "property", "og:url", url);
  next = upsertMeta(next, "property", "og:title", title);
  next = upsertMeta(next, "property", "og:description", description);
  next = upsertMeta(next, "property", "og:image", image);
  next = upsertMeta(next, "property", "og:image:secure_url", image);
  next = upsertMeta(next, "property", "og:image:type", "image/jpeg");
  next = upsertMeta(next, "property", "og:image:width", "1200");
  next = upsertMeta(next, "property", "og:image:height", "630");
  next = upsertMeta(next, "property", "og:image:alt", title);
  next = upsertMeta(next, "name", "twitter:url", url);
  next = upsertMeta(next, "name", "twitter:title", title);
  next = upsertMeta(next, "name", "twitter:description", description);
  next = upsertMeta(next, "name", "twitter:image", image);
  return next;
}

export function sharePages() {
  return Object.entries(PAGE_META).map(([route, meta]) => {
    const indexable = INDEXABLE_PATHS.some((re) => re.test(route));
    return {
      route,
      slug: route === "/" ? "home" : route.slice(1),
      title: meta.title,
      fullTitle: `${meta.title} | Awasource`,
      description: meta.description,
      kicker: route === "/" ? "Hiring platform" : meta.crumbs?.[1]?.name || "Awasource",
      url: `${SITE_URL}${route === "/" ? "/" : route}`,
      image: absoluteShareImage(route),
      robots: indexable
        ? "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        : "noindex, nofollow",
    };
  });
}
